/**
 * @generated SignedSource<<0f0d3097995716ea18e11cde2de44d22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetTabBarItemsFragment_session$data = {
  readonly currentClientProfile: {
    readonly id?: string;
    readonly member: {
      readonly club: {
        readonly appCustomization: {
          readonly externalLinks: ReadonlyArray<{
            readonly displayName: string;
            readonly url: string;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly copyOverrides: {
          readonly event: {
            readonly plural: string;
          } | null | undefined;
          readonly lesson: {
            readonly plural: string;
          } | null | undefined;
        } | null | undefined;
        readonly departments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly anyFacilityEventsEnabled: boolean;
              readonly anyFacilityLessonsEnabled: boolean;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly slug: string;
        readonly supportsPrivate: boolean;
        readonly supportsPublic: boolean;
        readonly " $fragmentSpreads": FragmentRefs<"useIsClubSellingMemberships_club" | "useIsClubSellingStandardPackages_club">;
      };
    } | null | undefined;
  } | null | undefined;
  readonly staffAccessAvailable: boolean;
  readonly user: {
    readonly activeMemberProfiles?: {
      readonly count: number;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly hidden: boolean | null | undefined;
          readonly member: {
            readonly club: {
              readonly slug: string;
            };
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentClubHasVisibleLessons_session" | "useGoToStore_session" | "useLessonTabHandler_session">;
  readonly " $fragmentType": "useGetTabBarItemsFragment_session";
};
export type useGetTabBarItemsFragment_session$key = {
  readonly " $data"?: useGetTabBarItemsFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetTabBarItemsFragment_session">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plural",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetTabBarItemsFragment_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "staffAccessAvailable",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGoToStore_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCurrentClubHasVisibleLessons_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useLessonTabHandler_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "activeMemberProfiles",
              "args": [
                {
                  "kind": "Literal",
                  "name": "active",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "hidden",
                  "value": false
                }
              ],
              "concreteType": "MemberProfileConnection",
              "kind": "LinkedField",
              "name": "memberProfiles",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "count",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MemberProfileEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MemberProfile",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hidden",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "member",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Club",
                              "kind": "LinkedField",
                              "name": "club",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "memberProfiles(active:true,hidden:false)"
            }
          ],
          "type": "MemberUser",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "type": "MemberProfile",
          "abstractKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useIsClubSellingStandardPackages_club"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useIsClubSellingMemberships_club"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPublic",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPrivate",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ClubCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "event",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "lesson",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AppCustomization",
                  "kind": "LinkedField",
                  "name": "appCustomization",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ExternalLink",
                      "kind": "LinkedField",
                      "name": "externalLinks",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DepartmentConnection",
                  "kind": "LinkedField",
                  "name": "departments",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DepartmentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Department",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "anyFacilityEventsEnabled",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "anyFacilityLessonsEnabled",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "5448bccea37ffc3f978e3437cc3233f3";

export default node;
